<!-- 包装信息弹窗 / 检验检疫签证申报要素-->
<template> 
    <div>
        <el-dialog :title="packageCode === 0 ? '编辑其他包装信息':'检验检疫签证申报要素'" :visible.sync="packageShow" width="60%" :before-close="handleClose" :close-on-click-modal="false">
            <el-table :data="packageTable" style="width: 100%" height="300px" size="mini" v-if="packageCode === 0" @selection-change="packageSelection">
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column type="index" width="50"> </el-table-column>
                <el-table-column prop="packType" label="包装材料种类代码" > </el-table-column>
                <el-table-column prop="packTypeName" label="包装材料种类名称"> </el-table-column>
            </el-table>
            <el-table :data="certificateTable" style="width: 100%" height="300px" size="mini" v-else @selection-change="certificateSelection">
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column type="index" width="50"> </el-table-column>
                <el-table-column prop="appCertCode" label="证书代码" > </el-table-column>
                <el-table-column prop="appCertName" label="证书名称"> </el-table-column>
                <el-table-column prop="applOri" label="正本数量"> </el-table-column>
                <el-table-column prop="applCopyQuan" label="副本数量"> </el-table-column>
            </el-table>
            <el-form ref="formValue" :model="formValue" label-width="170px" size="mini" v-if="packageCode === 1">
                <el-form-item label="境内收发货人名称(外文)">
                    <el-input placeholder="请输入境内收发货人名称(外文)"></el-input>
                </el-form-item>
                <el-form-item label="境外收发货人名称(中文)">
                    <el-input placeholder="请输入境外收发货人名称(中文)"></el-input>
                </el-form-item>
                <el-form-item label="境外发货人地址" v-if="exportCode === 'I' || exportCode === 'IML'">
                    <el-input placeholder="请输入境外发货人地址"></el-input>
                </el-form-item>
                <el-form-item label="卸毕日期" v-if="exportCode === 'I' || exportCode === 'IML'">
                    <el-date-picker class="width_100" value-format="yyyy-MM-dd"  type="date" placeholder="选择卸毕日期"> </el-date-picker>
                </el-form-item>
                <el-form-item label="商品英文名称" >
                    <div class="top_flex" style="margin: 0px;">
                        <el-input :disabled="true" v-model="gNameEnText" placeholder=""></el-input>
                        <span class="enterprise_buttons">
                            <el-button @click="goodsEnglishOpen()" icon="el-icon-more" circle size="mini" style="margin-left: 10px;"></el-button>
                        </span>
                    </div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleClose">保  存</el-button>
            </span>
        </el-dialog>

        <el-dialog title="编辑商品英文名称" :visible.sync="goodsShow" width="60%" :before-close="handleCloseGoods" :close-on-click-modal="false">
            <el-table :data="decList" style="width: 100%" height="200px" size="mini" @selection-change="goodsEnSelection">
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column type="index" width="50"> </el-table-column>
                <el-table-column prop="codeTs" label="商品编号" > </el-table-column>
                <el-table-column prop="gName" label="商品名称"> </el-table-column>
                <el-table-column prop="" label="商品英文名称"> 
                    <template slot-scope="scope">
                        <el-input size="mini" v-model="scope.row.gNameEn"></el-input>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="gNameEnSure">保  存</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import AEObasicData from '@/config/AEObasicData.js'

export default {
    props: {
        packageShow: {
            type: Boolean,
            default: false
        },
        packageCode: {
            type: Number,
            default: 0, // 0 包装信息  1 检验检疫签证申报要素
        },
        // 进口出口
        exportCode:{
            type: String,
            default: ''
        },
        // 商品列表
        decList:{
            type: Array,
            default:[]
        }
    },
    data() {
        return {
            packageTable:AEObasicData.CUS_MAPPING_PACKAGEKIND_CODE_V,
            certificateTable:AEObasicData.certificateList,
            packageList:[],
            certificateList:[],
            goodsEnList:[],
            formValue:{},
            gNameEnText:'',
            // 商品英文弹窗
            goodsShow:false,
        }
    },
    mounted() { 

    },
    methods: { 
        handleClose() {
            this.$emit('packageClose', false);
        },
        packageSelection(val){
            this.packageList = val
        },
        certificateSelection(val){
            this.certificateList = val
        },
        // 商品英文名称弹窗
        goodsEnglishOpen(){
            if(this.gNameEnText !== ''){
                const list = this.gNameEnText.split(",")
                for(var item of list){
                    const index = item.charAt(0)
                    const dashIndex = item.indexOf("-");
                    this.decList[index-1].gNameEn = item.substring(dashIndex + 1)
                }
            }
            this.goodsShow = true
        },
        // 选中商品
        goodsEnSelection(val){
            this.goodsEnList = val
        },
        // 确认英文名称
        gNameEnSure(){
            if(this.goodsEnList.length){
                var nameItem = '';
                var name = this.goodsEnList.map(item => {
                    nameItem += item.gNameEn?(item.gNo + '-' + item.gNameEn):''
                    nameItem += ','
                    return nameItem
                })
                this.gNameEnText = nameItem.slice(0, -1)
            }else{
                this.gNameEnText = ''
            }
            this.goodsShow = false
        },
        handleCloseGoods(){
            this.goodsShow = false
        },
    }
}
</script>
<style lang="css" scoped>
.width_100{
    width: 100%;
}
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
.top_flex{
    margin: 0px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.top_flex .el-button--mini {
    padding: 3px 4px;
    font-size: 12px;
}
</style>